import { render, staticRenderFns } from "./AddGenericFunctionDetail.vue?vue&type=template&id=422f5694&scoped=true"
import script from "./AddGenericFunctionDetail.vue?vue&type=script&lang=js"
export * from "./AddGenericFunctionDetail.vue?vue&type=script&lang=js"
import style0 from "./AddGenericFunctionDetail.vue?vue&type=style&index=0&id=422f5694&prod&scoped=true&lang=css"
import style1 from "./AddGenericFunctionDetail.vue?vue&type=style&index=1&id=422f5694&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f5694",
  null
  
)

export default component.exports